import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/authStore'
import { Footer } from '@/components/layout/Footer'

export function AuthLayout() {
  const { isAuthenticated, isLoading } = useAuthStore()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-700 mx-auto mb-4"></div>
          <p className="text-slate-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="text-center mb-8">
            <div className="inline-block w-16 h-16 bg-primary-700 rounded-xl flex items-center justify-center mb-4">
              <span className="text-white font-bold text-2xl">FJ</span>
            </div>
            <h1 className="text-2xl font-bold text-slate-900">Flight Journal</h1>
            <p className="text-slate-500 mt-1">Diário de Bordo Eletrônico</p>
          </div>
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  )
}
